import type { ICell } from 'models/interfaces/spreadsheet-types/core-types';

// First-column display format is inherited from the host cell.
export interface InheritedCellFormat {
  gridType: ICell['gridType'];
  format: ICell['format'];
  currency: ICell['currency'];
  dbDecimalPlaces?: number;
  maxDecimalDigits?: number;
}

export const extractFormatFromCell = (
  cell: Pick<ICell, 'gridType' | 'format' | 'currency' | 'dbDecimalPlaces' | 'maxDecimalDigits'>
): InheritedCellFormat => ({
  gridType: cell.gridType ?? null,
  format: cell.format ?? null,
  currency: cell.currency,
  dbDecimalPlaces: cell.dbDecimalPlaces,
  maxDecimalDigits: cell.maxDecimalDigits ?? undefined,
});
